export default __webpack_public_path__ + "static/media/valle-del-naidi.a3de8b38.svg";